import type { DrawerProps } from '@mui/material/Drawer';

const COLLAPSED_SIDE_NAV_WIDTH = 56;
const SIDE_NAV_AWARE_DRAWER_MAX_WIDTH = `calc(100vw - ${COLLAPSED_SIDE_NAV_WIDTH}px)`;

const drawerSx: DrawerProps['sx'] = {
  zIndex: (theme) => theme.zIndex.drawer,
};

const sideNavAwareDrawerPaperSx: DrawerProps['sx'] = {
  '& .MuiDrawer-paper': {
    boxSizing: 'border-box',
    maxWidth: SIDE_NAV_AWARE_DRAWER_MAX_WIDTH,
  },
};

export const mergeDrawerSx = (baseSx: DrawerProps['sx'], sx: DrawerProps['sx']): DrawerProps['sx'] => {
  if (!sx) {
    return baseSx;
  }

  const baseSxArray = Array.isArray(baseSx) ? baseSx : [baseSx];
  const sxArray = Array.isArray(sx) ? sx : [sx];
  return [...baseSxArray, ...sxArray] as DrawerProps['sx'];
};

export const getDrawerSx = (sx?: DrawerProps['sx']): DrawerProps['sx'] =>
  mergeDrawerSx([drawerSx, sideNavAwareDrawerPaperSx] as DrawerProps['sx'], sx);
